import React, { useCallback } from 'react';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { ViewAllEntityMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/view-all-entity-menu-item/index.tsx';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';
import { fg } from '@atlassian/jira-feature-gating';

import { CUSTOMER_SERVICE_HREF } from '../index.tsx';

const CSM_EXPERIENCES_HREF = '/jira/customer-service-management/experiences';

export const ViewAllExperiencesMenuItem = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const href = fg('csm_appification_standalone_navigation')
		? CSM_EXPERIENCES_HREF
		: CUSTOMER_SERVICE_HREF;

	const viewAllExperiencesClickHandler = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), {
			action: 'clicked',
			actionSubject: 'navigationItem',
			actionSubjectId: 'customerExperiencesViewAllMenuItem',
			attributes: {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM,
				itemId: 'viewAllExperiences',
			},
		});
	}, [createAnalyticsEvent]);

	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<ViewAllEntityMenuItem
						href={href}
						menuId={MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL}
						onClick={viewAllExperiencesClickHandler}
					>
						{formatMessage(viewAllExperiencesMessage)}
					</ViewAllEntityMenuItem>
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
};

const viewAllExperiencesMessage = defineMessage({
	id: 'navigation-apps.sidebar-nav4.customer-service.view-all-experiences',
	defaultMessage: 'View all experiences',
	description: 'Message for the view all customer experiences menu item',
});
